const validateDNI = data => {
    const dni = data.replace('-', '').trim().toUpperCase()
    var reg = new RegExp('^[0-9]{8}$');
    return reg.test(dni)
}


export default validateDNI